import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const PrepareOrder = () => {
    document.title = "Sifarişin formalaşması";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Alışlar", value: "/supplies" },
        { name: "Sifarişin formalaşması", value: "/supplies/prepareorder", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sifarişin formalaşması</h2>
                    <p>
                        Məhsula təyin olunan minimal qalıqdan sifariş üçün məhsullar formalaşır. Siyahıda olan məhsulları filter vasitəsi ilə çeşidləyərək (
                        təchizatçıya görə, məhsul qrupuna görə, anbar qalığı 0-a düşən məhsullara görə və s. ) sifaris yarat düyməsi ilə siyahıda olan
                        məhsullara görə təchizatçılara sifarişlər hazırlanır. Növbəti mərhələdə sifarişi təchizatçıya göndərdikdən sonra sifarişi alış sənədinə
                        çevirmək olar. Bu halda sifarış sənədinin statusunu dəyişə bilərsiniz. <Button>Filter</Button> düyməsini sıxıb müxtəlif parametrlərə
                        (təchizatçı, siyahı, anbar və s.) görə məhsulları <Button>Axtar</Button> düyməsinə sıxıb təyin etmək lazımdır. Daha sonra
                        <Button>Sifarişi hazırla</Button> düyməsini sıxıb sifarişləri formalaşdırmaq lazımdır.
                    </p>
                    <img src="/images/supplies/prepareorder.gif" alt="Sifarişin formalaşması" />
                </article>
            </div>
        </div>
    );
};
